<template>
  <div>
    <button @click="input('1')">1</button>
    <button @click="input('2')">2</button>
    <button @click="input('3')">3</button>
    <button @click="input('4')">4</button>
    <button @click="input('5')">5</button>
    <button @click="input('6')">6</button>
    <button @click="input('7')">7</button>
    <button @click="input('8')">8</button>
    <button @click="input('9')">9</button>

    <button @click="input('0')">0</button>
    <button @click="input('.')">.<sub>decimal</sub></button>
  </div>
</template>

<script>
  import _Services from "./_Services";

export default {
  extends: _Services,

  props: {
    role: {
      type: String,
      default: ['master', 'slave'][1]
    }
  },

  methods: {
    input: function (val) {
      let str = this.serviceContent;

      if(typeof str == 'undefined'){
        str = '';
      }

      //not leading 0
      if (val == '0' && (str == '')) {
        this.log('leading zero detected');
        return;
      }

      //not extra decimal point
      if (val == '.') {
        if (str == '') {
          str = '0';
        }
        if (str.includes('.')) {
          return;
        }
      }

      this.serviceContent = str.concat(val);
    }
  },

  computed: {

    events: function () {
      if(this.role != 'master'){
        return;
      }

      return this.$read('events');
    },
  },

  watch: {
    serviceContent: function (fresh, stale){
      if(this.role == 'master'){
        this.$write('sta.'.concat(this.locus), fresh);
      }
    },

    events: function (fresh, stale) {
      if (this.role != 'master') {
        return;
      }

      switch (fresh) {
        case 'recorded.miss':
        case 'recorded.hit':
        case 'game.lost':
        case 'game.new':
          this.serviceContent = '';
          break;
      }
    }
  }
}
</script>

<style scoped>
div {
  height: 100%;
  border: 1px solid #abcdef;
  justify-self: center;

  display: grid;

  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 1fr;
}

div > * {
  font-size: 2em;
  overflow: hidden;

  border: 1px solid #abcdef;
  color: #8fc5ea;


  text-align: center;
  text-decoration: none;
  cursor: pointer;

  background-color: white;
}

div > *:nth-last-child(1) {

}

div > *:nth-last-child(2) {
  grid-column: 1 / 3;

}

div > * > sub {
  display: block;
  font-size: 0.5em;
}
</style>